import { Link } from 'react-router-dom';

import { useEmbedBootstrap } from '../use-widget-bootstrap';
import { useQuerySuffix } from '../widget-hooks/useQuerySuffix';
import { PATH } from '../widget-lib/path-routes';

type HubItem = {
  title: string;
  description: string;
  path: string;
  module?: string;
  hideOnWidgetTypes?: string[];
};

const HUB_ITEMS: HubItem[] = [
  { title: 'Расписание', description: 'Сетка доступных слотов и фильтры.', path: PATH.schedule },
  { title: 'Записаться', description: 'Выбор услуги, времени и подтверждение.', path: PATH.book },
  { title: 'Мои записи', description: 'Актуальные и прошедшие записи.', path: PATH.bookings },
  { title: 'Тренеры', description: 'Список тренеров и карточки.', path: PATH.trainers, module: 'fitness' },
  { title: 'Услуги', description: 'Каталог услуг и деталей.', path: PATH.services },
  { title: 'Абонементы', description: 'Покупка и управление абонементами.', path: PATH.subscriptionPlans, module: 'subscriptions' },
  { title: 'Мои абонементы', description: 'Активные карты и сертификаты.', path: PATH.mySubscriptions },
  { title: 'Профиль', description: 'Персональные данные и настройки.', path: PATH.account }
];

function greetingName(fullName: string | null | undefined): string | null {
  const first = (fullName ?? '').trim().split(/\s+/)[0]?.trim();
  return first || null;
}

const heroPrimaryLinkClass =
  'inline-flex min-h-10 shrink-0 items-center justify-center rounded-full bg-[var(--accent-bg)] px-5 text-[13px] font-semibold text-[var(--accent-fg)] shadow-sm transition hover:bg-[var(--accent-bg-hover)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)]';

const heroSecondaryLinkClass =
  'inline-flex min-h-10 shrink-0 items-center justify-center rounded-full border border-[var(--border)] bg-[var(--bg-elevated)]/90 px-5 text-[13px] font-semibold text-[var(--text)] backdrop-blur-sm transition hover:bg-[var(--bg-soft)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)]';

export default function ClientHubPage() {
  const {
    me,
    effectiveModules,
    widgetContour,
    accessToken,
    orgSlug
  } = useEmbedBootstrap();
  const suffix = useQuerySuffix();
  const modules = effectiveModules ?? me?.modules ?? null;
  const items = HUB_ITEMS.filter(
    (item) =>
      (!item.module || !orgSlug || modules?.[item.module] === true) &&
      (!item.hideOnWidgetTypes || !item.hideOnWidgetTypes.includes(widgetContour ?? ''))
  );

  const hello = accessToken ? greetingName(me?.full_name) : null;

  if (widgetContour === 'mobile') {
    return (
      <section className="space-y-4 rounded-2xl border border-[var(--border)] bg-[var(--bg-elevated)] p-4 shadow-[var(--shadow-card)] sm:p-5">
        <header>
          <h1 className="text-xl font-semibold tracking-tight text-[var(--text)]">Все возможности</h1>
          <p className="mt-1 text-sm leading-relaxed text-[var(--text-muted)]">
            Основные разделы — в нижней панели. Здесь краткая карта и переход к расписанию.
          </p>
        </header>
        <Link
          to={`${PATH.schedule}${suffix}`}
          className="inline-flex min-h-10 w-full items-center justify-center rounded-full bg-[var(--accent-bg)] px-5 text-sm font-semibold text-[var(--accent-fg)] shadow-sm transition hover:bg-[var(--accent-bg-hover)]"
        >
          К расписанию
        </Link>
      </section>
    );
  }

  return (
    <section className="space-y-6">
      {hello ? (
        <p className="text-sm text-[var(--text-muted)]">Здравствуйте, {hello}.</p>
      ) : null}

      <div className="flex flex-wrap gap-2">
        <Link to={`${PATH.schedule}${suffix}`} className={heroPrimaryLinkClass}>
          Расписание
        </Link>
        <Link to={`${PATH.book}${suffix}`} className={heroSecondaryLinkClass}>
          Записаться
        </Link>
        {accessToken ? (
          <Link to={`${PATH.account}${suffix}`} className={heroSecondaryLinkClass}>
            Личный кабинет
          </Link>
        ) : (
          <Link to={`${PATH.signIn}${suffix}`} className={heroSecondaryLinkClass}>
            Вход
          </Link>
        )}
      </div>

      <div>
        <h2 className="text-lg font-semibold tracking-tight text-[var(--text)]">Все разделы</h2>
        <p className="mt-1 text-sm text-[var(--text-muted)]">Выберите сценарий — те же маршруты, что в навигации сверху.</p>
        <div className="mt-4 grid gap-3 sm:grid-cols-2">
          {items.map((item) => (
            <Link
              key={item.path}
              to={`${item.path}${suffix}`}
              className="rounded-2xl border border-[var(--border)] bg-[var(--bg-elevated)] p-4 shadow-sm transition hover:bg-[var(--bg-soft)]"
            >
              <p className="text-sm font-semibold text-[var(--text)]">{item.title}</p>
              <p className="mt-1 text-xs leading-snug text-[var(--text-muted)]">{item.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
